module.exports = __webpack_public_path__ + "static/media/search.07880a1f.svg";